var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTxt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 48,
    viewBox: "0 0 40 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_154_2121)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M27.9279 9.84959C26.8344 9.84853 25.7858 9.41379 25.0124 8.64071C24.2389 7.86762 23.8037 6.8193 23.8021 5.72574V0H5.37688C3.94954 0 2.58065 0.567023 1.57137 1.5763C0.562091 2.58558 -0.00488281 3.95442 -0.00488281 5.38176V37.8244C-0.00488281 39.2517 0.562091 40.6206 1.57137 41.6299C2.58065 42.6392 3.94954 43.2062 5.37688 43.2062H27.496C28.9233 43.2062 30.2922 42.6392 31.3014 41.6299C32.3107 40.6206 32.8777 39.2517 32.8777 37.8244V9.84959H27.9279Z",
    fill: "#0072FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.8779 9.84959H27.9281C26.8345 9.84853 25.786 9.41379 25.0125 8.64071C24.2391 7.86762 23.8038 6.8193 23.8022 5.72574V0L32.8779 9.84959Z",
    fill: "#0072FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1139 16.7453H5.46476C5.26655 16.7447 5.07662 16.6657 4.93647 16.5256C4.79631 16.3854 4.71732 16.1955 4.7168 15.9973C4.7168 15.7987 4.79552 15.6083 4.93573 15.4677C5.07595 15.3271 5.26621 15.2478 5.46476 15.2473H26.1139C26.3125 15.2478 26.5027 15.3271 26.6429 15.4677C26.7831 15.6083 26.8619 15.7987 26.8619 15.9973C26.8613 16.1955 26.7824 16.3854 26.6422 16.5256C26.502 16.6657 26.3121 16.7447 26.1139 16.7453Z",
    fill: "#0072FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1139 21.2191H5.46476C5.26655 21.2186 5.07662 21.1396 4.93647 20.9995C4.79631 20.8593 4.71732 20.6694 4.7168 20.4712C4.7168 20.2726 4.79552 20.0821 4.93573 19.9415C5.07595 19.801 5.26621 19.7217 5.46476 19.7212H26.1139C26.3125 19.7217 26.5027 19.801 26.6429 19.9415C26.7831 20.0821 26.8619 20.2726 26.8619 20.4712C26.8613 20.6694 26.7824 20.8593 26.6422 20.9995C26.502 21.1396 26.3121 21.2186 26.1139 21.2191Z",
    fill: "#0072FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1139 25.693H5.46476C5.26621 25.6925 5.07595 25.6132 4.93573 25.4727C4.79552 25.3321 4.7168 25.1416 4.7168 24.943C4.71732 24.7448 4.79631 24.5549 4.93647 24.4147C5.07662 24.2746 5.26655 24.1956 5.46476 24.1951H26.1139C26.3121 24.1956 26.502 24.2746 26.6422 24.4147C26.7824 24.5549 26.8613 24.7448 26.8619 24.943C26.8619 25.1416 26.7831 25.3321 26.6429 25.4727C26.5027 25.6132 26.3125 25.6925 26.1139 25.693Z",
    fill: "#0072FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1139 30.1647H5.46476C5.26639 30.1647 5.07615 30.0859 4.93588 29.9456C4.79561 29.8053 4.7168 29.6151 4.7168 29.4167C4.7168 29.2182 4.79552 29.0277 4.93573 28.8871C5.07595 28.7465 5.26621 28.6673 5.46476 28.6667H26.1139C26.3125 28.6673 26.5027 28.7465 26.6429 28.8871C26.7831 29.0277 26.8619 29.2182 26.8619 29.4167C26.8619 29.6151 26.7831 29.8053 26.6428 29.9456C26.5025 30.0859 26.3123 30.1647 26.1139 30.1647Z",
    fill: "#0072FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7813 34.1206H11.7744C10.0005 34.1206 8.5625 35.5586 8.5625 37.3325V44.7882C8.5625 46.562 10.0005 48 11.7744 48H36.7813C38.5552 48 39.9932 46.562 39.9932 44.7882V37.3325C39.9932 35.5586 38.5552 34.1206 36.7813 34.1206Z",
    fill: "#0072FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1065 42.6743V44.1283H15.6006V42.6743H17.1065Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.184 38.1145V39.2725H20.5501V44.1282H19.0882V39.2725H17.4702V38.1145H22.184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4462 44.1282L25.1782 42.2563L24.0883 44.1282H22.4223L24.3443 41.0323L22.3623 38.1145H24.0883L25.3222 39.9264L26.3862 38.1145H28.0441L26.1481 41.1424L28.1721 44.1282H26.4462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0536 38.1145V39.2725H31.4216V44.1282H29.9577V39.2725H28.3418V38.1145H33.0536Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_154_2121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.9983,
    height: 48,
    fill: "white",
    transform: "translate(-0.00488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxt);
export default __webpack_public_path__ + "static/media/TXT.fdf169539f83246c3f2f59a5d54c283e.svg";
export { ForwardRef as ReactComponent };